import {
	CHANGE_SELECTED_SOLICITOR_USERS,
	CHANGE_SOLICITOR_USERS_LIST_SETTINGS,
	CHANGE_SOLICITOR_DISPLAYED_USERS,
	CHECK_ALL_SOLICITOR_USERS,
	CHECK_SOLICITOR_USER,
	TOGGLE_MODAL,
	FILTER_BY_LAWSYS,
	RECEIVE_GET_SOLICITORS,
	RECEIVE_UPDATE_CHECKED_SOLICITORS,
	REQUEST_GET_SOLICITORS,
	REQUEST_UPDATE_CHECKED_SOLICITORS,
	SOLICITOR_USERS_AGENTS_FILTER,
	SOLICITOR_USERS_PAGE_SHIFT,
	CHANGE_LAWSYS_ID,
	TOGGLE_CONFIRM_DIALOG,
	RECEIVE_BAD_REQUEST_GET_SOLICITORS,
	CHANGE_AGENTS_LIST_SETTINGS,
	REQUEST_GET_SOLICITORS_SUGGESTIONS,
	RECEIVE_GET_SOLICITORS_SUGGESTIONS,
	RECEIVE_BAD_RESPONSE_GET_SOLICITORS_SUGGESTIONS,
	SORT_AGENTS_LIST,
	GET_SOLICITOR_USER_COLLEAGUES, GET_SOLICITOR_USER_COLLEAGUES_SUCCESS, GET_SOLICITOR_USER_COLLEAGUES_FAILED
} from "./index";

export function getSolicitorUserColleagues(payload) {
	return {
		type: GET_SOLICITOR_USER_COLLEAGUES,
		payload: payload
	}
}

export function getSolicitorUserColleaguesSuccess(payload) {
    return {
        type: GET_SOLICITOR_USER_COLLEAGUES_SUCCESS,
        payload: payload
    }
}

export function getSolicitorUserColleaguesFailed(payload) {
    return {
        type: GET_SOLICITOR_USER_COLLEAGUES_FAILED,
        payload: payload
    }
}

export function sortAgentsList(payload) {
    return {
        type: SORT_AGENTS_LIST,
        payload: payload
    }
}

export function checkSolicitorUser(payload) {
	return {
		type: CHECK_SOLICITOR_USER,
		payload
	}
}

export function changeSolicitorDisplayedUsers(data) {
	return {
		type: CHANGE_SOLICITOR_DISPLAYED_USERS,
		payload: data
	}
}

export function checkAllSolicitorUsers(payload) {
	return {
		type: CHECK_ALL_SOLICITOR_USERS,
		payload
	}
}

export function changeSolicitorUsersListSettings(settingKey, value) {
	return {
		type: CHANGE_SOLICITOR_USERS_LIST_SETTINGS,
		payload: {
			key: settingKey,
			value: value
		}
	}
}

export function solicitorUsersPageShift(direction) {
	return {
		type: SOLICITOR_USERS_PAGE_SHIFT,
		payload: direction
	}
}

export function solicitorUsersAgentsFilter(filteredAgents) {
	return {
		type: SOLICITOR_USERS_AGENTS_FILTER,
		payload: filteredAgents
	}
}

//Change checked soicitors
// for action 'enable' status are enabled
//for action 'disable' status are disabled
export function changeSelectedSolicitorUsers(action) {
	return {
		type: CHANGE_SELECTED_SOLICITOR_USERS,
		payload: action
	}
}


//action that updated chekced users with the api
export function requestUpdateCheckedSolicitors(changedSolicitors) {
	return {
		type: REQUEST_UPDATE_CHECKED_SOLICITORS,
		payload: changedSolicitors
	}
}

//action that receives the response of the update request from the api
export  function receiveUpdateCheckedSolicitors(response){
	return {
		type: RECEIVE_UPDATE_CHECKED_SOLICITORS
	}
}


//action that makes the get request for the solicitors
export function requestGetSolicitors(payload) {
	return {
		type: REQUEST_GET_SOLICITORS,
		payload
	}
}

//action that receives the fetched solicitors from the get request
export function receiveGetSolicitors(solicitors) {
	return {
		type: RECEIVE_GET_SOLICITORS,
		payload: solicitors
	}
}

//action that receives bad request  fetching solicitors from the get request
export function receiveBadRequestGetSolicitors(response) {
	return {
		type: RECEIVE_BAD_REQUEST_GET_SOLICITORS,
		payload: response
	}
}

//action that filters by lawsys
export function filterByLawsys(lawsysId){
	return {
		type: FILTER_BY_LAWSYS,
		payload:lawsysId
	}
}




//action that closes and opens the displayed modal
export function toggleModal() {
	return {
		type: TOGGLE_MODAL
	}
}

//action that changes the lawsysId to be attached with the selected agents
export function changeLawsysId(payload) {
	return {
		type: CHANGE_LAWSYS_ID,
		payload
	}
}

//action that closes and opens the confirm modal
export function toggleConfirmDialog() {
	return {
		type: TOGGLE_CONFIRM_DIALOG
	}
}

//action that chagnes the agents list settings
export function changeAgentsListSettings(key, value) {
	return {
		type: CHANGE_AGENTS_LIST_SETTINGS,
		payload: {
			key,
			value
		}
	}
}



//action that makes the get request for the solicitors
export function requestGetSolicitorsSuggestions(payload) {
	return {
		type: REQUEST_GET_SOLICITORS_SUGGESTIONS,
		payload
	}
}

//action that receives the fetched solicitors from the get request
export function receiveGetSolicitorsSuggestions(solicitors) {
	return {
		type: RECEIVE_GET_SOLICITORS_SUGGESTIONS,
		payload: solicitors
	}
}

//action that receives bad request  fetching solicitors from the get request
export function receiveBadRequestGetSolicitorsSuggestions(response) {
	return {
		type: RECEIVE_BAD_RESPONSE_GET_SOLICITORS_SUGGESTIONS,
		payload: response
	}
}